module.exports = __webpack_public_path__ + "img/logo-branco-amorsaude copy.7a777720.svg";